<template>
  <div class="search-input">
    <WsText001 v-if="title" h6 bold>
      {{ $t(title) }}
    </WsText001>
    <div class="search-input_content">
      <i class="leading-icon icon-search" />
      <input
        class="searchInput"
        tabindex="0"
        type="text"
        :value="value"
        :placeholder="value ? '' : $t(placeholder)"
        @keyup.enter="enterOnchange($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '搜尋',
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    enterOnchange($event) {
      this.$emit('input', $event.target.value);
      this.$emit('enter');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/search-input';
</style>
